import { Component, OnInit } from '@angular/core';
import { NotificationService } from 'src/app/service/notification.service';
import { Notification } from 'src/app/manager/notification';
import { Router } from '@angular/router';
import { HeaderComponent } from 'src/app/common-components/header/header.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

 import { ColDef, GridOptions } from 'ag-grid-community';
import { AgGridModule } from 'ag-grid-angular';
import { CommonMessageModalComponent } from '../common-message-modal/common-message-modal.component';
import { BASE_AG_GRID_OPTIONS } from 'src/app/service/common-config';
@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css'],
  standalone: true,
  imports: [HeaderComponent, FormsModule, CommonModule,AgGridModule,CommonMessageModalComponent]
})
export class NotificationComponent implements    OnInit {
gridOptions: GridOptions = {
  pagination: true,
  paginationPageSize: 15,
  rowSelection : 'single',
    suppressColumnVirtualisation: true,
  suppressDragLeaveHidesColumns: true,
...BASE_AG_GRID_OPTIONS,
};

  Notifications: Notification[] = new Array<Notification>();
  constructor(private notificationservice: NotificationService, private route: Router) { }

  ngOnInit() {
    this.notification()
  }

  notification() {
    let time = 3000;
    this.notificationservice.notify.subscribe((res: any) => {
      // console.log('Before toast res : ', res.length);
      if (res && res.length == 0) {
        return null;
      }
      // console.log('After toast res : ', res.length);
      if (Array.isArray(res)) {
        if (res.length > 0) {
          if (res[0] && res[0].time) {
            time = res[0].time ? res[0].time : 3000;
          }
          res.forEach(e => {
            this.Notifications.unshift(e);
          });
        }
        setTimeout(() => {
          for (let i = 0; i < res.length; i++) {
            // setTimeout(() => {
              // this.Notifications.pop();
              if (res[i].Message == "Access Token is invalid, or has been expired.") {
                this.logOut()
              } else if (res[i].Message == "You are not authorized.") {
                this.logOut();
              } else if (res[i].Message == 'Please change your Password to visit this page') {
              }
            // }, i * 3000);
          }
        }, 1 * time);
      }
      else {
        let err = [];
        err.unshift(res)
        this.Notifications = (err)
        // setTimeout(() => {
          this.Notifications = [];
        // }, 1 * 3000);
      }
    })
  }
  logOut() {
    this.route.navigate(['/login']);
  }

  closeModalFun(event){
    this.Notifications = [];
  }
}
